import React from 'react';

export default () => (
  <section className='container-fluid black_more'>
        <div className='row m-10-hor'>

        <div className='col-12 text-center'>
          <div className='subheading'>Our Pricing</div>
          <div className='heading'>Easy Pricing</div>
          <div className='row'>
            <div className='col-md-8 mx-auto'>
              <p className='content'>
                Curabitur mollis bibendum luctus. 
                Duis suscipit vitae dui sed suscipit. Vestibulum auctor 
                nunc vitae diam eleifend, in maximus metus sollicitudin. 
                Quisque vitae sodales lectus. Nam porttitor justo sed mi finibus, 
                vel tristique risus faucibus. 
              </p>
            </div>
          </div>
        </div>

        <div className='col-md-3'>
          <div className='pricelist'>
            <div className="heading">Basic</div>
            <div className="bigprice"><span className='text-gradient'>$29</span> <small>Month</small></div>
            <ul className="list">
              <li><i className="fa fa-check"></i> Full Acces</li>
              <li><i className="fa fa-check"></i> Unlimited Bandwidth</li>
              <li><i className="fa fa-check"></i> Admin Panel</li>
              <li><i className="fa fa-check"></i> Email Account</li>
              <li><i className="fa fa-check"></i> 8 Weeks Free Service</li>
            </ul>
          </div>
        </div>

        <div className='col-md-3'>
          <div className='pricelist'>
            <div className="heading">Standard</div>
            <div className="bigprice"><span className='text-gradient'>$39</span> <small>Month</small></div>
            <ul className="list">
              <li><i className="fa fa-check"></i> Full Acces</li>
              <li><i className="fa fa-check"></i> Unlimited Bandwidth</li>
              <li><i className="fa fa-check"></i> Admin Panel</li>
              <li><i className="fa fa-check"></i> Email Account</li>
              <li><i className="fa fa-check"></i> 8 Weeks Free Service</li>
            </ul>
          </div>
        </div>

        <div className='col-md-3'>
          <div className='pricelist'>
            <div className="heading">Advanced</div>
            <div className="bigprice"><span className='text-gradient'>$49</span> <small>Month</small></div>
            <ul className="list">
              <li><i className="fa fa-check"></i> Full Acces</li>
              <li><i className="fa fa-check"></i> Unlimited Bandwidth</li>
              <li><i className="fa fa-check"></i> Admin Panel</li>
              <li><i className="fa fa-check"></i> Email Account</li>
              <li><i className="fa fa-check"></i> 8 Weeks Free Service</li>
            </ul>
          </div>
        </div>

        <div className='col-md-3'>
          <div className='pricelist'>
            <div className="heading">Premium</div>
            <div className="bigprice"><span className='text-gradient'>$59</span> <small>Month</small></div>
            <ul className="list">
              <li><i className="fa fa-check"></i> Full Acces</li>
              <li><i className="fa fa-check"></i> Unlimited Bandwidth</li>
              <li><i className="fa fa-check"></i> Admin Panel</li>
              <li><i className="fa fa-check"></i> Email Account</li>
              <li><i className="fa fa-check"></i> 8 Weeks Free Service</li>
            </ul>
          </div>
        </div>

        </div>
    </section>
  
);
